import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'
import {getMonitorList} from '@apis'
import './index.less'
import AddMonitor from './add-monitor'
import EZUIKit from 'ezuikit-js'
import monitorChoose from '@assets/img/lightChoose.png'

let timer

// 智慧安防
const CockpitMonitorControl = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {brokerId} = userInfo
    const [monitorList, setMonitorList] = useState([])
    const [monitorShowList, setMonitorShowList] = useState([])
    const [playerList, setPlayerList] = useState([])
    const [addMonitorVisible, setAddMonitorVisible] = useState(false)
    const [monitor, setMonitor] = useState()

    // 查询监控列表
    async function queryMonitorList() {
      const params = {
        brokerId,
        pageNo: 1,
        pageSize: 9999,
      }
      const res = await getMonitorList(params)
      if (res && res.data) {
        res.data.map(item => item.key = item.id)
        setMonitorList(res.data)
        setMonitorShowList(res.data.filter(item => {
          return item.dataBigscreenDisplay==1
        }))
      }
    }

    // 单击某个监控开始播放
    function playpro() {
      if(playerList[0]) {
        playerList[0].stop()
        playerList[0] = null
      }
      playerList[0] = new EZUIKit.EZUIKitPlayer({
        id: 'left_player',
        url: monitor.url.substring(0, monitor.url.length-5) + '.hd' + monitor.url.substring(monitor.url.length-5),
        autoplay: true,
        accessToken: monitor.monitorAccessToken,
        decoderPath: '{{location path}}',
        width: 1042,
        height: 862,
        handleError() {
          playerList[0].play()
        },
      });
      setPlayerList(playerList.slice())
    }

    // 右侧监控播放
    function playRight() {
      monitorShowList.map((item, index) => {
        let id = 'myPlay' + index
        playerList[index+1] = new EZUIKit.EZUIKitPlayer({
          id: id,
          url: item.url,
          autoplay: true,
          accessToken: item.monitorAccessToken,
          decoderPath: '{{location path}}',
          width: 365,
          height: 220,
          handleSuccess() {
          },
          handleError() {
            playerList[index+1].play()
          },
        });
      })
      setPlayerList(playerList.slice())
    }

    useEffect(() => {
      queryMonitorList()
    }, [])

    useEffect(() => {
      if(monitorShowList.length) {
        setMonitor(monitorShowList[0])
        playRight()
      }
    }, [monitorShowList])

    useEffect(() => {
      if(playerList.length > 1) {
        clearInterval(timer)
        timer = setInterval(() => {
          let href = window.location.href
          href = href.split('/')[href.split('/').length-1]
          if(href !== 'realtimeMonitor') {
            playerList.map(item => {
              item.stop()
            })
            clearInterval(timer)
          }
        }, 10000)
      }
    }, [playerList])

    useEffect(() => {
      if(monitor) {
        playpro()
        setInterval(() => {
          playpro()
        }, 600000)
      }
    }, [monitor])

    return (
      <React.Fragment>
        <div className="monitor-show">
          <div className='monitor-show-left'>
            <div id='left_player' className='left_player'></div>
          </div>
          <div className='monitor-show-right'>
            <div
              className='monitor-menu-choose'
              onClick={() => {setAddMonitorVisible(true)}}
            >
              <img
                className='monitor-menu-chooseImg'
                src={monitorChoose}
              />
              <div className='monitor-menu-chooseText'>编辑监控</div>
            </div>
            <div className='program-list clearfix'>
              {
                monitorShowList.map((item, index) => (
                  <div className='program-item-box'>
                    <div className='program-monitor'>
                      <div id={'myPlay' + index}></div>
                    </div>
                    <div className='program-title'>
                      {item.name}
                      {
                        monitor && monitor.url === item.url ? (
                          <span className='program-span'>: 正在展示中</span>
                        ) : null
                      }
                    </div>
                    <div
                      className='program-div'
                      onClick={() => {
                        if(monitor && item.url == monitor.url) return
                        setMonitor(item)
                      }}
                    ></div>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
        <AddMonitor
          visible={addMonitorVisible}
          switchVisible={setAddMonitorVisible}
          monitorList={monitorList}
          queryMonitorList={queryMonitorList}
        />
      </React.Fragment>
    )
  })
)

export default CockpitMonitorControl